import { React, useEffect } from "react";
import "./GameSettings.css";
import { useGlobalContext } from "../context";

const EngineStrengthPicker = () => {
  const { engineStrength, setEngineStrength, setGameAgainstComputer } =
    useGlobalContext();

  useEffect(() => {
    setEngineStrength(1000);
    setGameAgainstComputer(true);
  }, []);

  useEffect(() => {
    localStorage.setItem("engineStrength", engineStrength);
  }, [engineStrength]);

  return (
    <select
      className="options-list"
      defaultValue="1000"
      onChange={(e) => {
        if (e.target.value !== "original") {
          setEngineStrength(e.target.value);
        } else {
          setGameAgainstComputer(false);
          setEngineStrength(800);
        }
      }}
    >
      <option value="original">
        800 elo - autorski silnik (wariant klasyczny)
      </option>
      <option value="800">800 elo</option>
      <option value="900">900 elo</option>
      <option value="1000">1000 elo</option>
      <option value="1100">1100 elo</option>
      <option value="1200">1200 elo</option>
      <option value="1300">1300 elo</option>
    </select>
  );
};

export default EngineStrengthPicker;
